import CommonButton from 'components/Buttons/CommonButton';
import { RootState } from 'models';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const ForceValidationDetail = () => {
  const dispatch = useDispatch();
  const protocol = useSelector(selectors.documents.selectActiveDocumentID);
  const idProgram = useSelector(selectors.app.getProgramCode);
  const idUserQualityCheck = useSelector(selectors.user.getIdUser);
  const history = useHistory();
  const documents = useSelector(selectors.documents.selectAllActiveDocuments);
  const documentHeader = useSelector(selectors.documents.selectDocumentHeader);
  const t = utils.intl.useTranslator();

  const { val: CHECK_VENDOR_ON_FORCE_VALIDATE } = useSelector((store: RootState) =>
    selectors.app.getConfig(store, actionType.CHECK_VENDOR_ON_FORCE_VALIDATE),
  );
  const saveDocument = utils.hooks.useSaveDocument();
  const { checkDocuments } = useCheckBeforeAction(actionType.FORZACONVALIDA);
  const forceValidation = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    if (protocol && idUserQualityCheck) {
      try {
        if ((await saveDocument()) === null) throw new Error('error.saveDocument');
        await services.validateDocument({ idProgram, idUserQualityCheck, protocols: [protocol], forceSubmit: true });
        utils.app.notify('success', t('success-validation'), 5000);
        dispatch(actions.documents.removeRows([protocol]));
        dispatch(actions.documents.openNextDocument(history));
      } catch (e) {
        console.error(e);
      }
    }
  };

  return (
    <CommonButton
      id="force-validation-btn"
      disabled={
        !utils.user.isActionEnabled(documents, actionType.FORZACONVALIDA) ||
        (CHECK_VENDOR_ON_FORCE_VALIDATE && (!documentHeader?.subject || !documentHeader?.supplierCode))
      }
      action={forceValidation}
      scope="tertiary"
      value={t('force-val')}
      customIcon="double-check"
    />
  );
};

const ForceValidationlist = () => {
  const dispatch = useDispatch();
  const protocols = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const idProgram = useSelector(selectors.app.getProgramCode);
  const idUserQualityCheck = useSelector(selectors.user.getIdUser);
  const documents = useSelector(selectors.documents.selectAllActiveDocuments);

  const t = utils.intl.useTranslator();

  const forceValidation = async () => {
    if (protocols && idUserQualityCheck) {
      try {
        await services.validateDocument({ idProgram, idUserQualityCheck, protocols, forceSubmit: true });
        utils.app.notify('success', t('success-validation'), 5000);
        dispatch(actions.documents.removeRows(protocols));
      } catch (e) {
        console.error(e);
      }
    }
  };

  return (
    <CommonButton
      id="force-validation-list-btn"
      disabled={!utils.user.isActionEnabled(documents, actionType.FORZACONVALIDA)}
      action={forceValidation}
      scope="tertiary"
      value={t('force-val')}
      customIcon="double-check"
    />
  );
};

export { ForceValidationDetail, ForceValidationlist };
